var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:!_vm._isMobile ? 'wrapperPcY' : ''},[_c('img',{attrs:{"src":require("../assets/image/yywy-1.jpg")}}),_vm._v(" "),_c('img',{attrs:{"src":require("../assets/image/yywy-2.jpg")}}),_vm._v(" "),_c('img',{attrs:{"src":require("../assets/image/yywy-3.jpg")}}),_vm._v(" "),_c('img',{attrs:{"src":require("../assets/image/yywy-4.jpg")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab4bb726","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/yywy.vue
// module id = null
// module chunks = 